IN.App.ApplicationController = Ember.Controller.extend({
	history: [],
	hasHistory: function(){
		return this.get('history.length')>1;
	}.property('history.length'),
	watchHistory: function(){
		this.get('history').pushObject(this.get('currentPath'));
		IN.App.set('currentPath', this.get('currentPath'));
	}.observes('currentPath'),
	actions: {
		goBack: function(){
			var self = this;
		// implement your own history popping that actually works ;)
		if(this.get('hasHistory')){
				this.get('history').popObject();
				window.history.back(); 
				this.get('history').popObject(); // get rid of route change here, don't need it
			}
		}
	}
});
